import { useEffect } from 'react';
import { useAPIContext } from '../../../../components/Context';
import { useCallbackRef } from '../../../../utils';
import { useLocation } from '../../draft/location/hooks';
import { createTimeoutCache } from '../../utils';
import { useAuthorizationState } from '../authorization/hooks';
import { createAsyncState } from '../hooks';
export var useLocationAsync = createAsyncState('location');
var setCache = createTimeoutCache(500);
export var useLocationQuery = function () {
    var _a;
    var value = useLocation()[0].value;
    var _b = useLocationAsync(), asyncState = _b[0], actions = _b[1];
    var api = useAPIContext();
    var isAuthorized = ((_a = useAuthorizationState().data) === null || _a === void 0 ? void 0 : _a.authorization_status) === 'authorized';
    var location = isAuthorized && api.localitySuggest;
    var request = useCallbackRef(function (part) {
        if (!location) {
            return;
        }
        actions.start();
        return location({
            body: {
                part: part,
                kinds: ['country'],
                require_additional_fields: {
                    add_country_alpha3: true
                }
            },
            onError: actions.error,
            onSuccess: actions.success,
        });
    });
    useEffect(function () {
        if (value) {
            return setCache(function () { return request(value); });
        }
    }, [value, request]);
    useEffect(function () {
        if (!value) {
            return request('');
        }
        // добавила location в депсы, чтобы отправлять запрос сразу после авторизации
    }, [request, value, location]);
    return asyncState;
};
